"use client";

import { useBalance } from "wagmi";
import { contractAddresses } from "../../../../meta";
import { Card, Typography, FlexCol, Divider } from "../../../../shared";
import { displayTokens } from "../../../../utils";
import { useGetContractBalanceByToken } from "../../../state/erc20/useGetContractBalanceByToken";
import { HorizontalRow } from "../components/HorizontalRow/HorizontalRow";

export const DSOBalances = () => {
  const ethData = useBalance({ address: contractAddresses.OCHI });

  const { displayData: rwDisplayValueCHI } = useGetContractBalanceByToken(
    "CHI",
    contractAddresses.OCHI
  );
  const { displayData: rwDisplayValueStETH } = useGetContractBalanceByToken(
    "stETH",
    contractAddresses.OCHI
  );
  const { displayData: rwDisplayValueUSC } = useGetContractBalanceByToken(
    "USC",
    contractAddresses.OCHI
  );
  const { displayData: rwDisplayValueWETH } = useGetContractBalanceByToken(
    "WETH",
    contractAddresses.OCHI
  );

  return (
    <Card hasBorder className="p-4">
      <Typography>DSO(OCHI)/</Typography>
      <br />
      <FlexCol className="gap-2">
        <HorizontalRow
          name="ETH balance"
          value={displayTokens(ethData?.data?.value, {})}
          isFetched={ethData.isFetched}
        />
        <Divider />
        <HorizontalRow name="CHI balance" {...rwDisplayValueCHI} />
        <Divider />
        <HorizontalRow name="stETH balance" {...rwDisplayValueStETH} />
        <Divider />
        <HorizontalRow name="USC balance" {...rwDisplayValueUSC} />
        <Divider />
        <HorizontalRow name="WETH balance" {...rwDisplayValueWETH} />
      </FlexCol>
    </Card>
  );
};
